(function () {
if (!customElements.get("lsg-tablist")) customElements.define("lsg-tablist", class LSGTablist extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            tab: ".js-lsg-tab",
            tablist: ".js-lsg-tablist",
            tabpanel: ".js-lsg-tabpanel"
        };
        this.tabs = this.querySelectorAll(this.selectors.tab);
        this.tablist = this.querySelector(this.selectors.tablist);
        this.tabpanels = this.querySelectorAll(this.selectors.tabpanel);
        this.init();
    }
    init() {
        this.tablist.addEventListener('keydown', (e)=>{
            switch(e.key){
                case 'ArrowLeft':
                    this.selectPreviousTab();
                    break;
                case 'ArrowRight':
                    this.selectNextTab();
                    break;
                case 'Home':
                    e.preventDefault(); // prevent page scroll
                    this.selectFirstTab();
                    break;
                case 'End':
                    e.preventDefault(); // prevent page scroll
                    this.selectLastTab();
                    break;
            }
        });
        // Activate tabs when they are clicked (also handles Enter and Space keys)
        this.tabs.forEach((tab)=>{
            tab.addEventListener('click', (e)=>{
                this.nextTabIndex = Array.prototype.slice.call(this.tabs).indexOf(e.target);
                this.selectTab(this.nextTabIndex);
            });
        });
    }
    /**
     Tab selection
     */ selectPreviousTab() {
        var activeTab = this.querySelector(`${this.selectors.tab}[aria-selected="true"]`);
        var activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);
        // Select the previous tab, wrapping to last tab if needed
        if (activeTabIndex > 0) this.selectTab(activeTabIndex - 1);
        else this.selectTab(this.tabs.length - 1);
    }
    selectNextTab() {
        var activeTab = this.querySelector(`${this.selectors.tab}[aria-selected="true"]`);
        var activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);
        // Select the next tab, wrapping to the first tab if needed
        if (activeTabIndex < this.tabs.length - 1) this.selectTab(activeTabIndex + 1);
        else this.selectTab(0);
    }
    selectFirstTab() {
        this.selectTab(0);
    }
    selectLastTab() {
        this.selectTab(this.tabs.length - 1);
    }
    selectTab(index) {
        // Deactivate all tabs
        this.tabs.forEach((tab)=>{
            tab.setAttribute('aria-selected', false);
            tab.setAttribute('tabindex', -1);
        });
        // Activate only the requested tab, and set focus to it
        this.tabs[index].setAttribute('aria-selected', true);
        this.tabs[index].setAttribute('tabindex', 0);
        this.tabs[index].focus();
        // Hide all tabpanels
        this.tabpanels.forEach((tabpanel)=>{
            tabpanel.classList.remove('is-visible');
        });
        // Show only the tabpanel for the requested tab
        var nextTabpanel = this.querySelector('#' + this.tabs[index].getAttribute('aria-controls'));
        nextTabpanel.classList.add('is-visible');
    }
});

})();
